module.exports = __webpack_public_path__ + "static/Touchless_MonthTwo-8-4a2fa28c92c6a3140dfcaedb688673cb.jpg";